import { appFetch, AppFetchResponse } from "../utils/appFetch";
import {FilterProps} from "../components/table/tableTypes";

export const getCustomersReport = async (selectedDomain: string, filters: FilterProps[], page?: number, pageSize?: number): Promise<AppFetchResponse> => {
    const filtersArr: string[] = [];
    filters.forEach(filter => {
        if(filter.selected) {
            filtersArr.push(`${filter.filterKey}=${filter.selected}`);
        } else if(filter.value) {
            filtersArr.push(`${filter.filterKey}=${filter.value}`);
        }
    });
    return appFetch({
        endpoint: `reports/shop-clients?page=${page}&page_size=${pageSize}${filtersArr?.length ? `&${filtersArr.join('&')}` : ''}`,
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}